var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopHomepageBannerTablet(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1156.462,
    height: 1002.623,
    viewBox: "0 0 1156.462 1002.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    transform: "translate(221.08 316.481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Forma_portocalie_mare",
    "data-name": "Forma portocalie mare",
    d: "M83.571,434.489c125.3,71.708,311.684,9.853,387.193-57.054,98.12-86.948,217.714-343.125,112.6-417.392C523.5-82.234,347.873-11.776,273.7,103.834c-68.861,107.331-121.638,52.809-201.213,82.54C-28.2,223.988-23.521,373.209,83.571,434.489Z",
    transform: "translate(26.134 -272.098) rotate(32)",
    fill: "#ffdc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Forma_albastra_mare",
    "data-name": "Forma albastra mare",
    d: "M762.994.1c119.334,2.323,63.5,134.213,74.225,207.248,15.494,105.512,60.447,173.734,61.427,265.333.983,91.908,16.883,47.509-81.138,93.456C750.922,597.347,410.6,680.27,291.852,677.959-.635,672.264-25.284,557.673,3.563,396.432S470.507-5.6,762.994.1Z",
    transform: "translate(46.292 -124.335) rotate(9)",
    fill: "#78cfc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Circles_and_lines",
    "data-name": "Circles and lines",
    transform: "translate(-36.174 61.238) rotate(-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    transform: "translate(0 267.87)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.164,
    cy: 6.842,
    rx: 7.164,
    ry: 6.842,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.164,
    cy: 6.842,
    rx: 6.164,
    ry: 5.842,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    transform: "translate(347.601 420.353)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.373,
    cy: 5.132,
    rx: 5.373,
    ry: 5.132,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.373,
    cy: 5.132,
    rx: 4.373,
    ry: 4.132,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    transform: "translate(166.71 357.061)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.164,
    cy: 6.842,
    rx: 7.164,
    ry: 6.842,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.164,
    cy: 6.842,
    rx: 6.164,
    ry: 5.842,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    transform: "translate(181.038 302.322)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.582,
    cy: 3.421,
    rx: 3.582,
    ry: 3.421,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.582,
    cy: 3.421,
    rx: 2.582,
    ry: 2.421,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    transform: "translate(48.504 40.6)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.582,
    cy: 3.421,
    rx: 3.582,
    ry: 3.421,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.582,
    cy: 3.421,
    rx: 2.582,
    ry: 2.421,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    transform: "translate(497.562 390.995)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.059,
    cy: 6.842,
    rx: 8.059,
    ry: 6.842,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.059,
    cy: 6.842,
    rx: 7.059,
    ry: 5.842,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x2: 13.679,
    y2: 14.517,
    transform: "translate(97.896 291.969)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x1: 12.919,
    y2: 10.888,
    transform: "translate(124.304 0)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M8.63,0,0,19.808",
    transform: "translate(196.232 204.589)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M0,0,12.663,17.589",
    transform: "translate(448.221 487.989)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x2: 16.719,
    y2: 4.355,
    transform: "translate(51.539 126.477)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x1: 12.159,
    y2: 14.154,
    transform: "translate(243.786 354.807)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopHomepageBannerTablet);
export default __webpack_public_path__ + "static/media/topHomepageBannerTablet.b18c7c52a2a8a124b33f9afa6e631d50.svg";
export { ForwardRef as ReactComponent };